import { FrameName } from "../config";
import AbstractSalvageableTileEntity from "./AbstractSalvageableTileEntity";

class OldBattlefieldSalvageableTileEntity extends AbstractSalvageableTileEntity {
	public static readonly frameName = FrameName.OLD_BATTLEFIELD;
}

export default OldBattlefieldSalvageableTileEntity;
